import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { getItemMenu } from "../../assets/js/api";

export default function Creditos({ section_id }) {
    const location = useLocation();
    const [item, setItem] = useState(location.state?.item || null);

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header />
                <main id="main" className="is-relative mb-7">
                    <div className="wrapper wrapper--narrow flow--m">
                        <h1 className="has-text-centered">
                            {item ? item.term : "Cargando..."} {/* Mensaje de carga */}
                        </h1>
                        {item ? (
                            <div
                                dangerouslySetInnerHTML={{ __html: item.abstract }}
                            />
                        ) : (
                            <div></div>
                        )}
                    </div>
                </main>
                <Footer />
            </div>
        </Layout>
    );
}